import {useEffect, useState} from "react";

type Size = 'sm' | 'md' | 'lg' | 'xl' | '2xl'
export const sizes: Record<Size, string> = {
    'sm': '640px',
    'md': '768px',
    'lg': '1024px',
    'xl': '1280px',
    '2xl': '1536px',
}

export const isSmallerThanSize = (size: Size) => {
    const query = `(min-width: ${sizes[size]})`;
    return !window.matchMedia(query).matches;
}

export const isBiggerThanSize = (size: Size) => {
    const query = `(min-width: ${sizes[size]})`;
    return window.matchMedia(query).matches
}

export const useMediaQuery = (query: string) => {
    const [matches, setMatches] = useState(() => window.matchMedia(query).matches)
    useEffect(() => {
        const mql = window.matchMedia(query)
        const onChange = (e: MediaQueryListEvent) => setMatches(e.matches)
        setMatches(mql.matches)
        mql.addEventListener("change", onChange)
        return () => mql.removeEventListener("change", onChange)
    }, [query])
    return matches
}

export const useIsBiggerThanSize = (size: Size) =>
    useMediaQuery(`(min-width: ${sizes[size]})`)

export const useIsSmallerThanSize = (size: Size) =>
    !useIsBiggerThanSize(size)

export const useIsMobile = () =>
    !useIsBiggerThanSize('sm')
